export var WIDTH_ENUM = {
  values: ["xSmall", "small", "medium", "large", "xLarge"],
  widths: {
    xSmall: 352,
    small: 480,
    medium: 664,
    large: 768,
    xLarge: 872
  },
  defaultValue: "medium"
};
export var gutter = 60;
//# sourceMappingURL=shared-variables.js.map